import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBC6cWUx40hlDXXaC4VtzRS8av4fnGOK9c",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "gla-platform-2024.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "gla-platform-2024",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "gla-platform-2024.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "772119550480",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:772119550480:web:7c53ae617bb7244d404895"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// Configure Google Auth Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
